/* istanbul ignore file */
/* eslint-disable newline-per-chained-call */
import $ from 'jquery';
import uuid from 'uuid';
import {jwplayer8Script} from '@sinclair-digital/stl-common/src/jwplayer';

export const vidsvcs = function () {
    const vidsvcs = {
        then: jwplayer8Script.fetch().then,
        get player() {
            return jwplayer();
        },
    };

    const events = { // all events are in the player.* domain
        PLAYER_READY: 'player.ready',
        PLAYER_MEDIA_ENDED: 'player.mediaended',
        PLAYER_STATE_CHANGED: 'player.statechanged',
        PLAYER_ERROR: 'player.error',
        PLAYER_VOLUME_CHANGED: 'player.volumechanged',
        PLAYER_ON_ASSET_INFO: 'player.assetInfoAvailable',
        PLAYER_ON_ID3: 'player.onID3',
        PLAYER_AD_CLICKED: 'player.onAdClicked',
    };

    const env = (function (win, doc, nav) {
        const browser = {
            detect () {
                const os = this.search(this.data.os);
                const useFlash = false;
                return {
                    browser: this.search(this.data.browser),
                    version: this.search(nav.userAgent) || this.search(nav.appVersion),
                    os: this.search(this.data.os),

                    // only allow flash on non mobile devices now
                    useFlash,
                    hasFlash: useFlash,
                    iOS: /iPhone|iPod|iPad/.test(os),
                };
            },
            search (data) {
                if (typeof data === 'object') {
                    // search for string match
                    for (let i = 0; i < data.length; i++) {
                        const dataString = data[i].string,
                            dataProp = data[i].prop;
                        this.version_string = data[i].versionSearch || data[i].identity;
                        if (dataString) {
                            if (dataString.indexOf(data[i].subString) !== -1) {
                                return data[i].identity;
                            }
                        } else if (dataProp) {
                            return data[i].identity;
                        }
                    }
                } else {
                    // search for version number
                    const index = data.indexOf(this.version_string);
                    if (index === -1) return;
                    return parseFloat(data.substr(index + this.version_string.length + 1));
                }
            },
            data: {
                browser: [
                    {string: nav.userAgent, subString: 'Chrome', identity: 'Chrome'},
                    {string: nav.userAgent, subString: 'OmniWeb', versionSearch: 'OmniWeb/', identity: 'OmniWeb'},
                    {string: nav.vendor, subString: 'Apple', identity: 'Safari', versionSearch: 'Version'},
                    {prop: win.opera, identity: 'Opera', versionSearch: 'Version'},
                    {string: nav.vendor, subString: 'iCab', identity: 'iCab'},
                    {string: nav.vendor, subString: 'KDE', identity: 'Konqueror'},
                    {string: nav.userAgent, subString: 'Firefox', identity: 'Firefox'},
                    {string: nav.vendor, subString: 'Camino', identity: 'Camino'},
                    {string: nav.userAgent, subString: 'Netscape', identity: 'Netscape'},
                    {string: nav.userAgent, subString: 'MSIE', identity: 'Explorer', versionSearch: 'MSIE'},
                    {string: nav.userAgent, subString: 'Gecko', identity: 'Mozilla', versionSearch: 'rv'},
                    {string: nav.userAgent, subString: 'Mozilla', identity: 'Netscape', versionSearch: 'Mozilla'},
                ],
                os: [
                    {string: nav.platform, subString: 'Win', identity: 'Windows'},
                    {string: nav.platform, subString: 'Mac', identity: 'Mac'},
                    {string: nav.userAgent, subString: 'iPhone', identity: 'iPhone/iPod'},
                    {string: nav.userAgent, subString: 'iPad', identity: 'iPad'},
                    {string: nav.userAgent, subString: 'Android', identity: 'Android'},
                    {string: nav.userAgent, subString: 'Silk/', identity: 'Android'},
                    {string: nav.platform, subString: 'Linux', identity: 'Linux'},
                ],
            },
        };

        return browser.detect();
    })(window, document, navigator);

    const videoPlayer = {
        init () {

            let options = {};

            let cb = null;

            const playerID = 'vidsvcs_' + uuid();

            const video = vidsvcs.video;

            const attrs = {
                controls: true,
                id: playerID,
                width: '100%',
                height: '100%',
                vidsvcs_type: 'html5',
                vidsvcs_loaded: true,
            };

            if (arguments.length === 1) {
                if ($.isFunction(arguments[0])) {
                    cb = arguments[0];
                } else {
                    options = arguments[0];
                }
            } else if (arguments.length === 2) {
                // extend the options and params if they were given to us
                options = arguments[0];
                cb = arguments[1];
            }

            delete options.swfURL;
            delete options.expressInstall;
            delete options.params;

            if (options.attributes) {
                Object.assign(attrs, options.attributes);
                delete options.attributes;
            }

            Object.assign(attrs, options);

            // keep original content for cases where video element is not supported
            $(video).attr(attrs);

            const nosupport = $(this).children('[error=nohls]').detach();
            if (nosupport.get(0)) {
                this.data('error_nohls', nosupport);
            }

            $(video).bind('error', function (e) {
                const p = $(e.srcElement).parent();
                const target = e.target;
                p.trigger(events.PLAYER_ERROR, [target.error.code]);

                p.removeAttr('vidsvcs_loaded');
                p.empty(); //clear out the player
                const el = p.data('error_nohls');

                switch (target.error.code) {
                    case target.error.MEDIA_ERR_ABORTED:
                    case target.error.MEDIA_ERR_NETWORK:
                        break;
                    case target.error.MEDIA_ERR_SRC_NOT_SUPPORTED:
                    case target.error.MEDIA_ERR_DECODE:

                        if (el) {
                            el.css('display', 'block');
                            p.html(el);
                        }
                        break;
                    default:
                        break;
                }
            });

            $(video).bind('pause', function (e) {
                $(e.target).parent().trigger(events.PLAYER_STATE_CHANGED, ['pause']);
            });
            $(video).bind('play', function (e) {
                $(e.target).parent().trigger(events.PLAYER_STATE_CHANGED, ['play']);
            });
            $(video).bind('ended', function (e) {
                $(e.target).parent().trigger(events.PLAYER_MEDIA_ENDED);
            });
            $(video).bind('volumechange', function (e) {
                $(e.target).parent().trigger(events.PLAYER_VOLUME_CHANGED, [e.target.volume]);
            });

            if (cb) {
                this.bind(events.PLAYER_READY, cb);
            }

            this.trigger(events.PLAYER_READY, [video]);
            this.unbind(events.PLAYER_READY);

            return this;
        },

        destroy () {
            $(this).unbind('player'); // Unbind from all player.* events
            $(this).unbind('pause');
            $(this).unbind('ended');
            $(this).unbind('play');
            return this;
        },

        player () {
            return this;
        },

        loaded () {
            // return true if there is a player and it has loaded successfully
            return !!(vidsvcs.player.version && vidsvcs.player.getContainer().parentNode.parentNode);
        },

        ready () {
            return !!(vidsvcs.player.version && vidsvcs.player.getViewable());
        },

        setupConfig: {
            'file': '',
            'image': '',
            'width': '100%',
            'aspectratio': '16:9',
            'primary': !window.MediaSource ? 'flash' : 'html5', //for IE11 on Win7; deprecated in JW8
            'hlshtml': true,
            'hlsjsdefault': true,
            'androidhls': true,
            'autostart': false,
            'controls': true,
            'stagevideo': false,
            'bitrateKey': '',
            'liveTimeout': 0,
            'repeat': false,
        },

        /*** Player API ***/

        load (fileUrl, thumbUrl, overrideConfig = {}) {
            let config = videoPlayer.setupConfig;
            config.file = fileUrl;
            config.image = thumbUrl;
            config = {...config, ...overrideConfig};
            this.setup(config);
            this.load();
        },

        pause () {
            this.pause();
        },

        play (url) {
            if (arguments.length === 1) {
                this.src = url;
                this.load();
            }
            this.play();
        },

        stop () {
            this.stop ? this.stop() : this.pause();
        },

        currentTime (newTime) {
            if (arguments.length === 0) {
                return this.getCurrentTime();
            }
            this.seek(newTime);
        },

        muted (muted) {
            if (arguments.length === 0) {
                return this.getMute();
            }
            this.setMute(muted);
        },

        volume (volume) {
            if (arguments.length === 0) {
                return this.getVolume();
            }
            this.setVolume(volume);
        },

        duration () {
            return this.getDuration();
        },
    };

    $.fn.player = function playerFn(command, ...args) {
        vidsvcs.then(() => {
            if (!command) {
                return playerFn;
            }

            if (!videoPlayer.loaded() || command === 'load') {
                if (vidsvcs.player.version) vidsvcs.player.remove();
                jwplayer(this.get(0));
                videoPlayer.load.apply(vidsvcs.player, args);
            }

            if (!videoPlayer.ready() && command !== 'load') {
                return vidsvcs.player.on('viewable', () => {
                    $(this).player.apply(this, arguments);
                });
            }

            switch (typeof command) {
                case 'string':
                    return videoPlayer[command].apply(vidsvcs.player, args);
                case 'function':
                    return command.apply(videoPlayer, args);
                case 'object':
                    return command[args].call(videoPlayer, vidsvcs.player);
            }
        });
    };

    $.fn.getVidsvcs = () => vidsvcs;

    Object.assign(vidsvcs, {
        env,
        events,

        OnPlayerEvent (playerID, eventName, newState) {
            const player = $('#' + playerID);
            if (eventName === events.PLAYER_READY) {
                player.parent().attr('vidsvcs_loaded', 'true'); // #1842
                player.parent().trigger(events.PLAYER_READY, [player.get(0)]);
            } else if (eventName === events.PLAYER_MEDIA_ENDED) {
                player.parent().trigger(events.PLAYER_MEDIA_ENDED, [player.get(0)]);
            } else if (eventName === events.PLAYER_STATE_CHANGED) {
                // only forward certain events
                if (/play|pause|loading|loaded|seeking|buffering/.test(newState)) {
                    player.parent().trigger(events.PLAYER_STATE_CHANGED, [newState]);
                }
            } else if (eventName === events.PLAYER_VOLUME_CHANGED) {
                player.parent().trigger(events.PLAYER_VOLUME_CHANGED, [newState]);
            } else if (eventName === events.PLAYER_ON_ASSET_INFO) {
                player.parent().trigger(events.PLAYER_ON_ASSET_INFO, [newState]);
            } else if (eventName === events.PLAYER_ON_ID3) {
                player.parent().trigger(events.PLAYER_ON_ID3, [newState]);
            } else if (eventName === events.PLAYER_AD_CLICKED) {
                if (newState && newState.click && newState.click.length > 0) {
                    const e = $.Event(events.PLAYER_AD_CLICKED);
                    player.parent().trigger(e, [newState.click[0]]);
                    if (!e.isDefaultPrevented()) {
                        window.open(newState.click[0]);
                    }

                    // fire off the rest of the "tracking" clicks if there are any
                    for (let i = 1; i < newState.click.length; i++) {
                        $('<img src="' + newState.click[i] + '">').load(function () {
                        });
                    }
                }
            }
        },
    });

    return vidsvcs;
};

export default vidsvcs;
